import { useSnackbar } from 'notistack'
import React, { memo, useCallback } from 'react'
import { connect } from 'react-redux'

import { vaciar } from '../../../../../../../../models/movimiento/movimientoService'
import { closeDialog } from '../../../../../../../Forms/SharedComponents/containers/Dialog/actions/dialogActions'
import { actualizarEstadoSilos } from '../../../../../../actions'
import { OperacionVaciadoView } from '../components/OperacionVaciadoView'

export const OperacionVaciado = connect(null, { closeDialog, actualizarEstadoSilos })(
  memo(({ silo, closeDialog, actualizarEstadoSilos }) => {
    const { enqueueSnackbar } = useSnackbar()
    return (
      <OperacionVaciadoView
        silo={silo}
        aceptar={async () => {
          try {
            await vaciar(silo)
            closeDialog()
            enqueueSnackbar('Vaciado correcto')
            actualizarEstadoSilos()
          } catch (error) {
            enqueueSnackbar('Vaciado incorrencto', { variant: 'error' })
          }
        }}
        cancelar={useCallback(() => {
          closeDialog('VACIADO_SILO')
        }, [closeDialog])}
      />
    )
  })
)
